import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const getButtonStyle = (path: string) => {
    const baseStyle = "px-2 py-3 rounded-lg font-semibold text-sm transition-colors";
    return isActive(path)
      ? `${baseStyle} text-amber-300 border-blue-400`
      : `${baseStyle} text-gray-300 hover:text-white hover:border-gray-400`;
  };

  const handlePulseClick = () => {
    navigate('/');
  };

  const handleNotesClick = () => {
    navigate('/notes');
  };

  const handleNarrativesClick = () => {
    navigate('/narratives');
  };

  // const handleAlertsClick = () => {
  //   console.log('Alerts 버튼 클릭됨, /alerts로 이동 시도');
  //   navigate('/alerts');
  // };

  return (
    <nav className="flex space-x-2">
      <button
        onClick={handlePulseClick}
        className={getButtonStyle('/')}
      >
        Discover
      </button>
      <button
        onClick={handleNotesClick}
        className={getButtonStyle('/notes')}
      >
        Notes
      </button>
      <button
        onClick={handleNarrativesClick}
        className={getButtonStyle('/narratives')}
      >
        Narratives
      </button>
      {/* <button
        onClick={handleAlertsClick}
        className={getButtonStyle('/alerts')}
      >
        Alerts
      </button> */}
    </nav>
  );
};

export default Navigation; 